import { Component, OnInit, Input} from '@angular/core';
import { Months } from 'src/app/enums/months.enum';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Chart from 'chart.js/auto';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-statistics-chart',
  templateUrl: './statistics-chart.component.html',
  styleUrls: ['./statistics-chart.component.scss']
})
export class StatisticsChartComponent implements OnInit {
  public chartLine: any;
  @Input() dataLeft: number[] = [];


  constructor(
    //private adminservice: AdminService
  ) { }

  ngOnInit() {
    
  }

  ngAfterViewInit(){
    //this.createChartLine();
  };

  createChartLine() {
    let monthTemp = Months;
    let labelMonths = monthTemp.map((element)=>element.label)
    if (this.chartLine) {
      this.chartLine.destroy();
    }
    this.chartLine = new Chart('line', {
      type: 'line',
      plugins: [ChartDataLabels],
      data: {
        labels: [...labelMonths],
        datasets: [
          {
            label: 'Monto recaudado S/',
            data: this.dataLeft,
            backgroundColor: [
              'white'
            ],
            hoverBackgroundColor: [
              '#0A3245'
            ],
            hoverOffset: 1,
            pointRadius: 6,
            borderColor: '#0A3245',
          },
        ],
      },
      options: {
        aspectRatio: 2.5,
        plugins: {
          datalabels: {
            formatter: (value: any) => {
              return '';
            },
          },
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            grid: {
              borderDash: [3, 3],
              color: '#0A3245',
            },
          },
          y: {
            grid: {
              display: false,
              color: '#0A3245', 
            }
          },
        }
      },
    });
  }

}
